import React from 'react';
import { NavLink } from 'react-router-dom';

/**
 * PageSubNav — the universal sub-navigation line that sits directly
 * under a page's title. Links out to that page's detail views as real
 * routes, keeping navigation consistent across the app. Dark-themed.
 *
 * items: [{ id, label, to, end? }]
 */
export const PageSubNav = ({ items = [], className = '', rightSlot = null }) => (
  <nav
    className={`flex items-center gap-1 flex-wrap border-b border-[#1f2a44] pb-3 ${className}`}
    data-testid="page-sub-nav"
  >
    <div className="flex items-center gap-1 flex-wrap min-w-0">
      {items.map((it) => (
        <NavLink
          key={it.id}
          to={it.to}
          end={it.end}
          className={({ isActive }) =>
            `px-3 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap transition-colors ${
              isActive
                ? 'bg-[#44b6d2] text-[#04222b]'
                : 'text-slate-400 hover:text-slate-100 hover:bg-white/5'
            }`
          }
          data-testid={`subnav-${it.id}`}
        >
          {it.label}
        </NavLink>
      ))}
    </div>
    {rightSlot && <div className="ml-auto flex items-center shrink-0">{rightSlot}</div>}
  </nav>
);

export default PageSubNav;
